import { createTheme } from "@mui/material";
import { ThemeProvider } from "styled-components";
import { useState } from "react";
import ServiceTypeToggle from "../shared/ServiceTypeToggle";
import "../CommunicationTemplete/CommunicationTemplate.css";
import SubscriptionTemplate from "./SubscriptionTemplate";

const defaultTheme = createTheme();

const ManageSubscriptionTemplate = () => {
    const [activeTab, setActiveTab] = useState<"air" | "ocean">("air");

    return (
        <ThemeProvider theme={defaultTheme}>
            <div className="ctpl-page-header">
                <div className="ctpl-title-col">
                    <h1>Subscription Template</h1>
                    <p>Configure who receives WhatsApp &amp; email milestone alerts for each shipment mode.</p>
                </div>
                <ServiceTypeToggle onTypeChange={setActiveTab} activeTab={activeTab} width="320px" />
            </div>


            <SubscriptionTemplate mode={activeTab} />

        </ThemeProvider>
    );
};

export default ManageSubscriptionTemplate;